module.exports = __webpack_public_path__ + "static/img/7.991c261.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/6/1/9/zh/7.png
// module id = u7Kr
// module chunks = 0